import React from "react";

export function SectionTitle({ eyebrow, title, subtitle, center }) {
  return (
    <div className={`mb-12 ${center ? "text-center mx-auto max-w-2xl" : "max-w-3xl"}`}>
      {eyebrow && (
        <span className="text-xs font-semibold uppercase tracking-[0.2em] text-[var(--accent)]">
          {eyebrow}
        </span>
      )}
      <h2 className="font-head text-3xl sm:text-4xl font-extrabold tracking-tight mt-3">
        {title}
      </h2>
      {subtitle && (
        <p className="text-[var(--text-muted)] mt-4 text-base leading-relaxed">{subtitle}</p>
      )}
    </div>
  );
}
